<template>
  <div>
    <!-- Breadcrumb -->
    <app-breadcrumb>
      <template #contentright>
        <b-button
          variant="outline-primary"
          @click="openModal(null)"
        >
          <span class="text-nowrap">
            <feather-icon icon="PlusCircleIcon" /> {{ $t('Add New') }}
          </span>
        </b-button>
      </template>
    </app-breadcrumb>

    <!-- Table Container Card -->
    <b-row>
      <b-col
        md="6"
        offset-md="3"
      >
        <b-overlay
          :show="loading"
          spinner-variant="primary"
          spinner-type="grow"
          spinner-small
          rounded="sm"
        >
          <b-card
            title="Danh sách tài khoản"
            class="mb-0"
          >

            <b-card-text>
              Tài khoản đăng nhập MAM
            </b-card-text>

            <b-list-group>
              <b-list-group-item
                v-for="(item, index) in itemsData"
                :key="item.id"
                class="d-flex justify-content-between align-items-center"
              >
                <div>
                  <div class="text-primary">
                    <strong>{{ item.name }}</strong>
                  </div>
                  <div class="text-muted">
                    {{ item.description }}
                  </div>
                  <div>{{ item.username }}</div>
                </div>
                <div>
                  <b-button
                    variant="flat-secondary"
                    class="btn-icon"
                    @click="openModal(item)"
                  >
                    <feather-icon icon="Edit3Icon" />
                  </b-button>
                  <b-button
                    variant="flat-danger"
                    class="btn-icon"
                    @click="confirmDelete(item)"
                  >
                    <feather-icon icon="TrashIcon" />
                  </b-button>
                </div>
              </b-list-group-item>
            </b-list-group>

          </b-card>
        </b-overlay>
      </b-col>
    </b-row>
    <!-- modal login-->
    <b-modal
      id="modal-edit-position"
      :title="title"
      size="lg"
      :ok-only="true"
      ok-title="Đóng"
      hide-footer
      centered
    >
      <MAMAccountForm
        :exist-data="itemData"
        @closeEditModal="closeModal"
      />
    </b-modal>
  </div>
</template>

<script>
import {
  BOverlay, BCard, BListGroup, BListGroupItem, BButton,
  BBadge, BCardText, BRow, BCol, BModal, BForm, BFormInvalidFeedback, BFormTextarea,
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { ref, watch } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import { showToast } from '@/@core/utils/utils'
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import store from '@/store';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  required, alphaNumDot, max,
} from '@validations';
import formValidation from '@core/comp-functions/forms/form-validation'
import useMAMAccount from './useMAMAccount'
import MAMAccountForm from './MAMAccountForm.vue'

export default {
  components: {
    AppBreadcrumb,
    BOverlay,
    BRow,
    BCol,
    BCard,
    BCardText,
    BButton,
    BFormTextarea,
    BFormInput,
    BFormGroup,
    BBadge,
    BListGroup,
    BListGroupItem,
    BModal,
    BForm,
    BFormInvalidFeedback,
    ValidationProvider,
    ValidationObserver,
    MAMAccountForm,
  },
  data() {
    return {
      required,
      alphaNumDot,
      max,
      title: '',
    }
  },
  setup() {
    const isAddNewUserSidebarActive = ref(false)
    const dataOptions = ref([])
    const loadingEdit = ref(false)
    const defaultItemData = {
      name: '',
      description: '',
    }
    const itemData = ref(JSON.parse(JSON.stringify(defaultItemData)))
    const resetItemData = () => {
      itemData.value = JSON.parse(JSON.stringify(defaultItemData))
    }

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetItemData)

    const onSubmit = () => {
      loadingEdit.value = true;

      store.dispatch('files/updateMamAccount', { id: itemData.value.id, positionData: itemData.value })
        .then((response) => {
          loadingEdit.value = false
          if (response.status === 200) {
            if (response.data.code === 200) {
              showToast(response.data.message, { variant: 'success' });
            } else {
              showToast(response.data.message)
            }
          }
        })
    }

    const {
      loading,
      fetchMAMAccounts,
      tableColumns,
      perPage,
      currentPage,
      totalEntries,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      itemsData,

      // UI
      resolveUserPositionVariant,
      resolveUserPositionIcon,
      resolveUserStatusVariant,
      resolveUserStatusText,

      // Extra Filters
      dataFilter,
      statusFilter,

      statusOptions,
    } = useMAMAccount()

    fetchMAMAccounts();

    return {
      fetchMAMAccounts,
      // Sidebar
      isAddNewUserSidebarActive,
      loading,
      tableColumns,
      perPage,
      currentPage,
      totalEntries,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      itemsData,

      // Filter
      avatarText,

      // UI
      resolveUserPositionVariant,
      resolveUserPositionIcon,
      resolveUserStatusVariant,
      resolveUserStatusText,

      dataOptions,
      statusOptions,

      // Extra Filters
      dataFilter,
      statusFilter,

      loadingEdit,
      itemData,
      refFormObserver,
      getValidationState,
      resetForm,
      resetItemData,
      onSubmit,
    }
  },

  methods: {
    openModal(item) {
      this.title = item ? 'Cập nhật tài khoản' : 'Tạo mới tài khoản';
      this.itemData = item
      this.$bvModal.show('modal-edit-position')
    },
    closeModal(reloadList) {
      // console.log('closeModal', reloadList);
      if (reloadList) {
        this.fetchMAMAccounts();
      }
      this.$bvModal.hide('modal-edit-position')
    },
    confirmDelete(item) {
      this.$swal({
        title: 'Bạn chắc muốn xóa?',
        text: 'Xóa dữ liệu sẽ ảnh hưởng đến các chức năng khác trong hệ thống!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Có',
        cancelButtonText: 'Không',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('files/destroyMamAccount', { id: item.id }).then((res) => {
            if (res.status === 200) {
              this.fetchMAMAccounts();
              showToast(res.data.message, { variant: 'success' });
            } else {
              showToast(res.data.message);
            }
          })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
